import ButtonHelpToAccess from './ButtonHelpToAccess'
import { HELP_TO_ACCESS_PATH } from './ButtonHelpToAcess.constants'

export default ButtonHelpToAccess

export { HELP_TO_ACCESS_PATH }
